import { Component, OnInit } from '@angular/core'
import { environment } from '../environments/environment'
import { AppService } from './app.service'
import { MatSnackBar } from '@angular/material/snack-bar'

@Component({
  selector: 'phdsoft-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public get appVersion(): string {
    return `v.${environment.appVersion}`
  }

  constructor(
    private appService: AppService,
    public readonly snack: MatSnackBar
  ) { }

  async ngOnInit(): Promise<void> {
    this.appService.start()

    document.addEventListener('touchstart', this.preventPullToRefresh, { passive: false });
    document.addEventListener('touchmove', this.preventPullToRefresh, { passive: false });
  }

  preventPullToRefresh(event: TouchEvent) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }
}
